import React from 'react';
import { AlertCircle } from 'lucide-react';

export const profileCard =
  'rounded-2xl border border-slate-700/50 bg-slate-800/50 p-5 shadow-2xl shadow-purple-950/30 backdrop-blur-xl transition-all duration-300 sm:p-6';

export const inputClass =
  'w-full rounded-lg border border-slate-700/70 bg-slate-950/60 px-4 py-3 text-sm text-white outline-none transition placeholder:text-gray-500 focus:border-purple-400/80 focus:bg-slate-950/80 focus:ring-4 focus:ring-purple-500/15';

export const subtleButton =
  'inline-flex items-center justify-center gap-2 rounded-lg border border-slate-700/60 bg-slate-800/70 px-4 py-2.5 text-sm font-semibold text-white transition hover:border-purple-400/60 hover:bg-purple-500/20 hover:shadow-lg hover:shadow-purple-500/20 focus:outline-none focus:ring-4 focus:ring-purple-500/15';

export const dangerButton =
  'inline-flex items-center justify-center gap-2 rounded-xl border border-red-300/20 bg-red-400/10 px-3 py-2 text-sm font-semibold text-red-200 transition hover:border-red-300/40 hover:bg-red-400/15 focus:outline-none focus:ring-4 focus:ring-red-300/10';

export const FieldError = ({ children }) => {
  if (!children) return null;

  return (
    <p className="mt-2 inline-flex items-center gap-1.5 text-sm font-medium text-red-200">
      <AlertCircle className="h-4 w-4" />
      {children}
    </p>
  );
};

export const SectionHeader = ({ icon: Icon, eyebrow, title, action }) => (
  <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
    <div className="flex items-start gap-3">
      {Icon && (
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg shadow-purple-500/25">
          <Icon className="h-5 w-5" />
        </span>
      )}
      <div>
        {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-purple-300">{eyebrow}</p>}
        <h2 className="mt-1 text-xl font-bold text-white">{title}</h2>
      </div>
    </div>
    {action}
  </div>
);
